import { Text, View } from "@react-pdf/renderer";
import {
  IDefaultProcedure,
  IPatientResponsibilityProcedure,
} from "types/Order/Order";

type UniqueProcedureList = IDefaultProcedure | IPatientResponsibilityProcedure;

export function ServicesProvidedList({
  styles,
  uniqueProcedureList,
}: {
  styles: any;
  uniqueProcedureList: UniqueProcedureList[];
}) {
  return (
    <View style={styles.subsection}>
      <Text style={styles.title}>Service Details</Text>

      {uniqueProcedureList.map((currentProcedure) => (
        <Text style={styles.text} key={currentProcedure.code}>
          <Text style={styles.subtitle}>{currentProcedure.code}</Text> -{" "}
          {currentProcedure.cptDescription}
        </Text>
      ))}
    </View>
  );
}
